import { render, staticRenderFns } from "./dialogPosition.vue?vue&type=template&id=5e58d0ea&scoped=true&"
import script from "./dialogPosition.vue?vue&type=script&lang=js&"
export * from "./dialogPosition.vue?vue&type=script&lang=js&"
import style0 from "./dialogPosition.vue?vue&type=style&index=0&id=5e58d0ea&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e58d0ea",
  null
  
)

export default component.exports